//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FooterTop from '~/components/footer/footerTop.vue'
import FeatureContainer from '~/components/forCompanies/FeatureContainer.vue'
import DescriptionCard from '~/components/forGaming/DescriptionCard.vue'
import TopScreen from '~/components/TopScreen.vue'
import ItemDescription from '~/components/pagsmile-dashboard/ItemDescription.vue'
import ItemDescription2 from '~/components/pagsmile-dashboard/ItemDescription2.vue'

export default {
  components: {
    TopScreen,
    FooterTop,
    FeatureContainer,
    DescriptionCard,
    ItemDescription,
    ItemDescription2
  },
  head () {
    return {
      title: this.$t('footer.solutions.dashboard').concat(' | Pagsmile '),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('seo.description')
        }
      ]
    }
  },
  data () {
    return {
      componentFlag: false,
      selectedDescription: ItemDescription,
      currentItem: '1',
      options: [
        {
          value: '1',
          displayName: this.$i18n.t('pagsmile-dashboard.block2.item1.title')
        },
        {
          value: '2',
          displayName: this.$i18n.t('pagsmile-dashboard.block2.item2.title')
        },
        {
          value: '3',
          displayName: this.$i18n.t('pagsmile-dashboard.block2.item3.title')
        },
        {
          value: '4',
          displayName: this.$i18n.t('pagsmile-dashboard.block2.item4.title')
        },
        {
          value: '5',
          displayName: this.$i18n.t('pagsmile-dashboard.block2.item5.title')
        },
        {
          value: '6',
          displayName: this.$i18n.t('pagsmile-dashboard.block2.item6.title')
        },
        {
          value: '7',
          displayName: this.$i18n.t('pagsmile-dashboard.block2.item7.title')
        },
        {
          value: '8',
          displayName: this.$i18n.t('pagsmile-dashboard.block2.item8.title')
        },
        {
          value: '9',
          displayName: this.$i18n.t('pagsmile-dashboard.block2.item9.title')
        },
        {
          value: '10',
          displayName: this.$i18n.t('pagsmile-dashboard.block2.item10.title')
        }
      ]
    }
  },
  methods: {
    changeComponent ($event, item) {
      $event.preventDefault()
      if (this.currentItem !== item) {
        if (this.componentFlag) {
          this.selectedDescription = ItemDescription
          this.componentFlag = false
        } else {
          this.selectedDescription = ItemDescription2
          this.componentFlag = true
        }
        this.currentItem = item
      }
    }
  }
}
